import { render } from "./LeaveApply.vue?vue&type=template&id=7f1835ad"
import script from "./LeaveApply.vue?vue&type=script&lang=js"
export * from "./LeaveApply.vue?vue&type=script&lang=js"

import exportComponent from "/var/webapps/orangehrm/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__